import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../features/auth/authContext.js';

export const RequireAuth: React.FC = () => {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isLoading) {
    return (
      <main className="auth-state-screen" aria-busy="true">
        Verifying your session…
      </main>
    );
  }
  if (!auth.currentUser) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const isPasswordUser =
    auth.userProfile?.authProvider === 'password' ||
    (!auth.userProfile && auth.currentUser.email !== null);
  const requiresVerification = isPasswordUser && !auth.currentUser.emailVerified;

  if (requiresVerification) {
    return <Navigate to="/verify-email" replace />;
  }

  return <Outlet />;
};
